import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CouponListLayer from "../components/CouponListLayer";

const CouponListPage = () => {
    return (
        <MasterLayout>
            <CouponListLayer />
        </MasterLayout>
    );
};

export default CouponListPage;
